import * as React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { ids } from 'app/area/administration/constants';

import { CodeListMeatballMenuProps } from './types';

import styles from './meatball-menu.scss';

export const CodeListMeatballMenu = (props: CodeListMeatballMenuProps) => {

  const { codetableId, breadcrumbs, codeItem, translation,
    codeAccessConfiguration: { canCreate, canDelete, canDuplicate },
    deleteCodeItem } = props;

  const description = !!codeItem && !!codeItem.childrenCount
    ? translation.delete_with_descendants_confirm.replace('<DESCENDANTS>', String(codeItem.childrenCount))
    : translation.delete_confirm;

  const isVisible = codeItem.id !== 0 && canCreate;
  const hasNoAccess = !canDelete && !canCreate;

  const handleDeleteCodeItem = () => {
    deleteCodeItem(codetableId, codeItem.id, translation.code_item_successfully_deleted);
  };

  return isVisible ? <div className={styles.meatballContainer}>
    {<MeatballMenu
      id={ids.list_search_item(codeItem.id)}
      className={styles.meatball}>
      {hasNoAccess
        ? <li>
          <p className={styles.labelNoAccess}>{translation.no_access_has_been_granted}</p>
        </li>
        : <>
          {canDuplicate && <li>
            <Link to={routeConstants.indicatorFactorsAdministrationDuplicateCodeFor(breadcrumbs, codeItem.id)}
              className="dropdown-item">
              {!!translation && translation.duplicate_code}
            </Link>
          </li>}

          {canDelete && <li>
            <PromptConfirmationModal
              title={translation.delete_code_item}
              description={description}
              continueText={translation.delete_code_item}
              cancelText={translation.cancel}
              onContinue={handleDeleteCodeItem}>
              <button type="button" className="dropdown-item">
                {!!translation && translation.delete}
              </button>
            </PromptConfirmationModal>
          </li>}
        </>}
    </MeatballMenu>}
  </div> : null;
};
